const list_languages = 'list_languages';

var _is_dark_mode = false;
const app_config = 'app_config';
export const cache = {
    setLanguages,
    getLanguages,
    clearStorage,
    setAppConfig,
    getAppConfig,
    getDarkMode
}

function setLanguages(languages) {
    languages = JSON.stringify(languages);
    localStorage.setItem(list_languages, languages);
}

function getLanguages() {
    let data = localStorage.getItem(list_languages);
    if (data) {
        data = JSON.parse(data);
    }
    return data;
}

function clearStorage() {
    
}


function setAppConfig(config) {
    _is_dark_mode = config && config.appearance && config.appearance.dark_mode;
    config = JSON.stringify(config);
    localStorage.setItem(app_config, config);
}

function getDarkMode() {
    return _is_dark_mode;
}


function getAppConfig() {
    let data = localStorage.getItem(app_config);
    if (data) {
        data = JSON.parse(data);
    }

    return data;
}
